import { BaseCard } from '@/components/uiKit/Cards/BaseCard';
import React, { ReactNode } from 'react';
import { ComponentsCardFilter, VisibilityConfig } from '@/components/uiKit/ComponentsFilter';
import { Varinat } from '@/types/shared/component-selector-variant.types';

interface FilterSideMenuProps<T> {
  items: T[];
  onFilterChange: (data: Record<string, string[]>) => void;
  title?: string | ReactNode;
  defaultSelected?: Record<string, string[]>;
  isOverflowing?: boolean;
  multiSelect?: boolean;
  uiUnits?: Record<string, unknown> | string[];
  groupKey?: string;
  onClick?: (comp: T) => void;
  variant?: Varinat;
  renderItemsCard?: ((item: T) => React.ReactNode) | undefined;
  visibilityConfig?: VisibilityConfig;
}
export function FilterSideMenu<T>({
  items,
  onFilterChange,
  title,
  defaultSelected,
  uiUnits,
  groupKey,
  onClick,
  variant,
  renderItemsCard,
  multiSelect = false,
  visibilityConfig,
}: FilterSideMenuProps<T>) {
  return (
    <BaseCard
      variant="wrapper"
      classNames={{
        card: 'h-full w-full flex flex-col',
        content: `flex-1 bg-gray-200 flex flex-col gap-2 overflow-y-auto scrollbar-thin pt-0.5 ${
          variant === 'subcomponents-enabled' ? 'bg-white rounded-b-lg px-0 gap-0' : ''
        }`,
        title: variant === 'subcomponents-enabled' ? 'bg-white rounded-t-lg p-0 font-semibold' : '',
      }}
      title={title}
    >
      <ComponentsCardFilter
        renderItemsCard={renderItemsCard}
        variant={variant}
        defaultSelected={defaultSelected}
        onFilterChange={(data: any) => {
          onFilterChange(data);
        }}
        components={items}
        multiSelect={multiSelect}
        isAccordion={false}
        uiUnits={Array.isArray(uiUnits) ? uiUnits : undefined}
        onClick={onClick}
        groupKey={groupKey}
        visibilityConfig={visibilityConfig}
      />
    </BaseCard>
  );
}
